import style from './dropdown.module.css'

const Dropdown = ({ label, name, value, onChange, options, className, placeholder = "Select an option" }) => {
  return (
    <div className={`${className} ${style.dropdown}`}>
      {label && <label htmlFor={name}>{label}</label>}
      <select
        id={name}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((opt) => (
          <option style={{color: "black", textTransform: "capitalize"}} key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
